var _style, _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigmaTechIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    style: {
      enableBackground: "new 0 0 45 45"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000025410958044672552580000010456234306177759631_);}\r\n\t.st1{fill:#0ACF83;}\r\n\t.st2{fill:#A259FF;}\r\n\t.st3{fill:#F24E1E;}\r\n\t.st4{fill:#FF7262;}\r\n\t.st5{fill:#1ABCFE;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 7.5,
    width: 30,
    height: 45
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000083791032654075043860000010643965629909220227_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000083791032654075043860000010643965629909220227_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15,45c4.1,0,7.5-3.4,7.5-7.5V30H15c-4.1,0-7.5,3.4-7.5,7.5C7.5,41.6,10.9,45,15,45z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7.5,22.5c0-4.1,3.4-7.5,7.5-7.5h7.5v15H15C10.9,30,7.5,26.6,7.5,22.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M7.5,7.5C7.5,3.4,10.9,0,15,0h7.5v15H15C10.9,15,7.5,11.6,7.5,7.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M22.5,0H30c4.1,0,7.5,3.4,7.5,7.5c0,4.1-3.4,7.5-7.5,7.5h-7.5V0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M37.5,22.5c0,4.1-3.4,7.5-7.5,7.5c-4.1,0-7.5-3.4-7.5-7.5S25.9,15,30,15C34.1,15,37.5,18.4,37.5,22.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaTechIcon);
export default __webpack_public_path__ + "static/media/figma-tech-icon.6def4597bb9f17aab4157d41e81554f7.svg";
export { ForwardRef as ReactComponent };